import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const PAGES = [
    { name: "Home", path: "/" },
    { name: "Potato Curry", path: "/potato-curry" },
    { name: "Meals", path: "/meals" },
    { name: "Mushroom Curry", path: "/mushroom-curry" },
    { name: "Mint Mojito", path: "/mint-mojito" },
    { name: "Charred Corn Salad", path: "/charred-corn-salad" },
    { name: "Egg in a Hole Sandwich", path: "/egg-in-a-hole-sandwich" },
    { name: "Watermelon Sorbet", path: "/watermelon-sorbet" },
    { name: "Mango Lassi", path: "/mango-lassi" },
    { name: "Aam Panna", path: "/aam-panna" },
    { name: "Virgin Muskmelon Mojito", path: "/virgin-muskmelon-mojito" },
    { name: "Vanilla Frappe", path: "/vanilla-frappe" },
    { name: "Games", path: "/games" },
    { name: "Offline Downloadable Games", path: "/offline-games" },
    { name: "Offline Game Hub (All Games in One File)", path: "/offline-games" },
    { name: "Megafile All Games", path: "/offline-games" },
    { name: "Snake (Offline)", path: "/offline-games" },
    { name: "Chess (Offline)", path: "/offline-games" },
    { name: "Highway Racer (Offline)", path: "/offline-games" },
    { name: "2048 (Offline)", path: "/offline-games" },
    { name: "Tetris (Offline)", path: "/offline-games" },
    { name: "Flappy Bird (Offline)", path: "/offline-games" },
    { name: "Pong (Offline, 2 Player)", path: "/offline-games" },
    { name: "Tron Lightcycles (Offline, 2 Player)", path: "/offline-games" },
    { name: "Minesweeper (Offline)", path: "/offline-games" },
    { name: "Wordle (Offline)", path: "/offline-games" },
    { name: "Solitaire Klondike (Offline)", path: "/offline-games" },
    { name: "Connect Four (Offline, 1P/2P)", path: "/offline-games" },
    { name: "Breakout (Offline)", path: "/offline-games" },
    { name: "Tank Battle (Offline, 2 Player)", path: "/offline-games" },
    { name: "Basketball (Offline, 1P/2P)", path: "/offline-games" },
    { name: "Basket Random (Offline, 1 Button Basketball)", path: "/offline-games" },
    { name: "Neon Soccer Duel (Offline, 2 Player)", path: "/offline-games" },
    { name: "Wizard Wars (Offline, 2 Player)", path: "/offline-games" },
    { name: "Jetpack Joust (Offline, 2 Player)", path: "/offline-games" },
    { name: "Sumo Bumpers (Offline, 2 Player)", path: "/offline-games" },
    { name: "Skyline Sprint (Offline Endless Runner)", path: "/offline-games" },
    { name: "Neon Night Pinball (Offline)", path: "/offline-games" },
    { name: "Midnight Mole Mayhem (Offline Whack-a-Mole)", path: "/offline-games" },
    { name: "Meteor Mesa Dino Dash (Offline)", path: "/offline-games" },
    { name: "Neon Flux Dash (Offline Geometry Dash Style)", path: "/offline-games" },
    { name: "Car Game", path: "/car-game" },
    { name: "Space Defenders", path: "/space-defenders" },
    { name: "Tic Tac Toe", path: "/tic-tac-toe" },
    { name: "Math", path: "/math" },
    { name: "Areas", path: "/areas" },
    { name: "Even or Odd", path: "/even-or-odd" },
    { name: "Factorial", path: "/factorial" },
    { name: "LCM", path: "/lcm" },
    { name: "Prime Numbers", path: "/prime-numbers" },
    { name: "Drawing", path: "/drawing" },
    { name: "Vivaan's Web Development", path: "/web-development" },
    { name: "Business Card", path: "/business-card" },
    { name: "Man Drawing", path: "/man" },
    { name: "Happy Diwali", path: "/happy_diwali" },
    { name: "India Flag", path: "/india_flag" },
    { name: "Keyboard", path: "/keyboard" },
    { name: "Stickman", path: "/stickman" },
    { name: "New Year", path: "/new_year" },
    { name: "Rainbow Turtle", path: "/rainbow_turtle" },
    { name: "Robot", path: "/robot" },
    { name: "Snacks", path: "/snacks" },
    { name: "Drinks", path: "/drinks" },
    { name: "Pop", path: "/pop" },
    { name: "Hindi Songs", path: "/hindi_songs" },
    { name: "Favorite Songs", path: "/favorite_songs" },
    { name: "Senorita", path: "/senorita" },
    { name: "Believer", path: "/believer" },
    { name: "Shape of You", path: "/shapeofyou" },
    { name: "Jee Le Zara", path: "/jee-le-zara" },
    { name: "Pasoori", path: "/pasoori" },
    { name: "Sandese Aate Hai", path: "/sandese-aate-hai" },
    { name: "Let Me Down Slowly", path: "/letmedownslowly" },
    { name: "Gulaabi Aankhen", path: "/gulaabi-aankhen" },
    { name: "Interstellar", path: "/interstellar" },
    { name: "Saiyaara", path: "/saiyaara" },
    { name: "Kal Ho Na Ho", path: "/kal-ho-na-ho" },
    { name: "Terms and Conditions", path: "/terms-and-conditions" },
    { name: "Velvety White Bean Tomato Stew", path: "/velvety_white_bean_tomato_stew" },
    { name: "Puff", path: "/puff" },
    { name: "Tofu Wrap", path: "/tofu-wrap" },
    { name: "Banana Pancakes", path: "/banana-pancakes" },
    { name: "Idli Platter", path: "/idli-platter" },
    { name: "Mix Vegetable Curry", path: "/mix-vegetable-curry" },
    { name: "Chilli Butter Pasta", path: "/chilli-butter-pasta" },
    { name: "Key Lime Pie", path: "/key-lime-pie" },
    { name: "Masala Chai", path: "/masala-chai" },
    { name: "Vegetable Cutlet", path: "/vegetable-cutlet" },
    { name: "Vanilla Milkshake", path: "/vanilla-milkshake" },
    { name: "Vanilla Ice Cream", path: "/vanilla-ice-cream" },
    { name: "Mango Pudding Weikfield", path: "/mango-pudding-weikfield" },
    { name: "Task Manager", path: "/task-manager" },
    { name: "ChoreVault", path: "/chorevault" },
    { name: "Sales Dashboard", path: "/sales-dashboard" },
    { name: "QuizPopz", path: "/quizpopz" },
    { name: "Abacus", path: "/abacus" },
    { name: "AbacusLab (Soroban, Mental Math, Tests)", path: "/abacus" },
    { name: "High Quality Video Games", path: "/high-quality-games" },
    { name: "Block Blast (C++/WebAssembly)", path: "/high-quality-games" },
    { name: "Bubble Blast (High Quality, Original)", path: "/high-quality-games" },
    { name: "Bubble Burst (High Quality, Original)", path: "/high-quality-games" },
    { name: "Chat", path: "/chat" },
];

export default function HeaderWithSearch() {
    const navigate = useNavigate();
    const location = useLocation();
    const [search, setSearch] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navRefs = useRef({});
    const chatUrl = process.env.REACT_APP_CHAT_URL || "https://vmcreation.com/chat";

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const isActivePath = (paths) => paths.includes(location.pathname);

    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMobileMenuOpen]);

    useEffect(() => {
        if (!search) setSuggestions([]);
        else {
            setSuggestions(
                PAGES.filter(p => p.name.toLowerCase().includes(search.toLowerCase()))
            );
        }
    }, [search]);

    useEffect(() => {
        function handleClickOutside(e) {
            if (
                navRefs.current.coding && navRefs.current.coding.contains(e.target)
            ) return;
            if (
                navRefs.current.piano && navRefs.current.piano.contains(e.target)
            ) return;
            if (
                navRefs.current.cooking && navRefs.current.cooking.contains(e.target)
            ) return;
            setOpenDropdown(null);
        }
        if (openDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [openDropdown]);

    function handleSearchKeyDown(e) {
        if (e.key === "Enter" && search.trim()) {
            const match = PAGES.find(
                p => p.name.toLowerCase() === search.trim().toLowerCase()
            );
            if (match) {
                navigate(match.path);
            } else if (suggestions.length > 0) {
                navigate(suggestions[0].path);
            }
            setSearch("");
            setSuggestions([]);
        }
    }

    function handleSuggestionClick(path) {
        setSearch("");
        setSuggestions([]);
        navigate(path);
    }

    const codingLinks = [
        { name: "Games", path: "/games" },
        { name: "Math", path: "/math" },
        { name: "Drawing", path: "/drawing" },
        { name: "Vivaan's Web Development", path: "/web-development" },
    ];
    const cookingLinks = [
        { name: "Drinks", path: "/drinks" },
        { name: "Meals", path: "/meals" },
        { name: "Snacks", path: "/snacks" },
    ];
    const pianoLinks = [
        { name: "Pop", path: "/pop" },
        { name: "Hindi Songs", path: "/hindi_songs" },
        { name: "Favorite Songs", path: "/favorite_songs" },
    ];

    function renderDropdown(links) {
        return (
            <ul className="dropdown-menu">
                {links.map(link => (
                    <li key={link.path}>
                        <Link
                            to={link.path}
                            className="dropdown-link"
                            onClick={() => setOpenDropdown(null)}
                        >
                            {link.name}
                        </Link>
                    </li>
                ))}
            </ul>
        );
    }

    function renderMobileMenu() {
        return (
            <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                <div className="mobile-search-container">
                    <input
                        className="mobile-search-input"
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                handleSearchKeyDown(e);
                                toggleMobileMenu();
                            }
                        }}
                        autoComplete="off"
                    />
                    {suggestions.length > 0 && (
                        <ul className="mobile-search-suggestions">
                            {suggestions.map(s => (
                                <li key={s.path} onMouseDown={() => {
                                    handleSuggestionClick(s.path);
                                    toggleMobileMenu();
                                }}>{s.name}</li>
                            ))}
                        </ul>
                    )}
                </div>
                <nav className="mobile-menu-nav">
                    <div className="mobile-menu-section">
                        <Link to="/" className="mobile-menu-link mobile-home-link" onClick={toggleMobileMenu}>
                            🏠 Home
                        </Link>
                    </div>
                    <div className="mobile-menu-section">
                        <h3>Coding Projects</h3>
                        <div className="mobile-menu-links">
                            {codingLinks.map(link => (
                                <Link key={link.path} to={link.path} className="mobile-menu-link" onClick={toggleMobileMenu}>
                                    {link.name}
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div className="mobile-menu-section">
                        <h3>Piano Covers</h3>
                        <div className="mobile-menu-links">
                            {pianoLinks.map(link => (
                                <Link key={link.path} to={link.path} className="mobile-menu-link" onClick={toggleMobileMenu}>
                                    {link.name}
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div className="mobile-menu-section">
                        <h3>Cooking Recipes</h3>
                        <div className="mobile-menu-links">
                            {cookingLinks.map(link => (
                                <Link key={link.path} to={link.path} className="mobile-menu-link" onClick={toggleMobileMenu}>
                                    {link.name}
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div className="mobile-menu-section">
                        <Link to="/chorevault" className="mobile-menu-link" onClick={toggleMobileMenu}>
                            🗄️ ChoreVault
                        </Link>
                        <Link to="/sales-dashboard" className="mobile-menu-link" onClick={toggleMobileMenu}>
                            💼 Sales Dashboard
                        </Link>
                        <Link to="/quizpopz" className="mobile-menu-link" onClick={toggleMobileMenu}>
                            ✨ QuizPopz
                        </Link>
                        <Link to="/abacus" className="mobile-menu-link" onClick={toggleMobileMenu}>
                            🧮 Abacus
                        </Link>
                        <Link to="/high-quality-games" className="mobile-menu-link" onClick={toggleMobileMenu}>
                            🎮 High Quality Video Games
                        </Link>
                        <a href={chatUrl} target="_blank" rel="noopener noreferrer" className="mobile-menu-link" onClick={toggleMobileMenu}>
                            💬 Chat
                        </a>
                    </div>
                </nav>
            </div>
        );
    }

    return (
        <>
            <header className="header">
                <Link to="/" className="logo" aria-label="VMCREATION home">
                    <img src="/vmcreation-logo.svg" alt="VMCREATION" className="site-logo-image" />
                </Link>
                <nav className="nav">
                    <div
                        ref={el => (navRefs.current.coding = el)}
                        style={{ position: "relative" }}
                        onMouseEnter={() => openDropdown !== "coding" && setOpenDropdown("coding")}
                    >
                        <button className={`nav-link nav-trigger ${isActivePath(["/games", "/math", "/drawing", "/web-development", "/business-card"]) ? "active" : ""}`} onClick={() => setOpenDropdown(openDropdown === "coding" ? null : "coding")}>Coding Projects</button>
                        {openDropdown === "coding" && renderDropdown(codingLinks)}
                    </div>
                    <div
                        ref={el => (navRefs.current.piano = el)}
                        style={{ position: "relative" }}
                        onMouseEnter={() => openDropdown !== "piano" && setOpenDropdown("piano")}
                    >
                        <button className={`nav-link nav-trigger ${isActivePath(["/pop", "/hindi_songs", "/favorite_songs"]) ? "active" : ""}`} onClick={() => setOpenDropdown(openDropdown === "piano" ? null : "piano")}>Piano Covers</button>
                        {openDropdown === "piano" && renderDropdown(pianoLinks)}
                    </div>
                    <div
                        ref={el => (navRefs.current.cooking = el)}
                        style={{ position: "relative" }}
                        onMouseEnter={() => openDropdown !== "cooking" && setOpenDropdown("cooking")}
                    >
                        <button className={`nav-link nav-trigger ${isActivePath(["/drinks", "/meals", "/snacks"]) ? "active" : ""}`} onClick={() => setOpenDropdown(openDropdown === "cooking" ? null : "cooking")}>Cooking Recipes</button>
                        {openDropdown === "cooking" && renderDropdown(cookingLinks)}
                    </div>
                    <div style={{ position: "relative" }}>
                        <Link to="/chorevault" className={`nav-link ${location.pathname === "/chorevault" ? "active" : ""}`}>ChoreVault</Link>
                    </div>
                    <div style={{ position: "relative" }}>
                        <Link to="/sales-dashboard" className={`nav-link ${location.pathname === "/sales-dashboard" ? "active" : ""}`}>Sales Dashboard</Link>
                    </div>
                    <div style={{ position: "relative" }}>
                        <Link to="/quizpopz" className={`nav-link ${location.pathname === "/quizpopz" ? "active" : ""}`}>QuizPopz</Link>
                    </div>
                    <div style={{ position: "relative" }}>
                        <Link to="/abacus" className={`nav-link ${location.pathname === "/abacus" ? "active" : ""}`}>🧮 Abacus</Link>
                    </div>
                    <div style={{ position: "relative" }}>
                        <Link to="/high-quality-games" className={`nav-link ${location.pathname === "/high-quality-games" ? "active" : ""}`}>🎮 High Quality Video Games</Link>
                    </div>
                    <div style={{ position: "relative" }}>
                        <a
                            href={chatUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`nav-link ${location.pathname === "/chat" ? "active" : ""}`}
                        >
                            💬 Chat
                        </a>
                    </div>
                </nav>
                <div className="search-container">
                    <button className="search-btn">Search</button>
                    <input
                        id="search-input"
                        className="search-input"
                        type="text"
                        placeholder="Type page name..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={handleSearchKeyDown}
                        autoComplete="off"
                    />
                    {suggestions.length > 0 && (
                        <ul className="search-suggestions">
                            {suggestions.map((s) => (
                                <li
                                    key={s.path}
                                    className="search-suggestion-item"
                                    onMouseDown={() => handleSuggestionClick(s.path)}
                                >
                                    {s.name}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <button
                    className={`mobile-menu-btn ${isMobileMenuOpen ? "active" : ""}`}
                    onClick={toggleMobileMenu}
                    aria-label="Toggle menu"
                >
                    <span />
                    <span />
                    <span />
                </button>
            </header>
            {renderMobileMenu()}
        </>
    );
}
